import React from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import Nav from "./components/Nav";
import RequireRole from "./components/RequireRole";

import ParticipantLogin from "./pages/ParticipantLogin";
import Participant from "./pages/Participant";
import VolunteerLoginGoogle from "./pages/VolunteerLoginGoogle";
import VolunteerCheckin from "./pages/VolunteerCheckin";
import VolunteerTeams from "./pages/VolunteerTeams";

import AdminLogin from "./pages/AdminLogin";
import AdminSlots from "./pages/AdminSlots";
import AdminRooms from "./pages/AdminRooms";
import AdminAssign from "./pages/AdminAssign";
import AdminVolunteers from "./pages/AdminVolunteers";
import AdminAdmins from "./pages/AdminAdmins";
import AdminAnalytics from "./pages/AdminAnalytics";
import AdminExceptions from "./pages/AdminExceptions";
import AdminHome from "./pages/AdminHome";
import VolunteerHome from "./pages/VolunteerHome";
import ParticipantHome from "./pages/ParticipantHome";
import AdminTeams from "./pages/AdminTeams";

function Shell({ children }) {
  return (
    <>
      <header className="bg-white border-b">
        <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="font-bold text-lg">
            Festum <span className="text-gray-500"></span>
          </Link>
          <Nav />
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-4 py-8">{children}</main>
      <footer className="py-6 text-center text-xs text-gray-500">
        © {new Date().getFullYear()} Saola Innovations Pvt Ltd. All rights reserved.
      </footer>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Shell><ParticipantLogin /></Shell>} />
        <Route path="/forbidden" element={<Shell><div className="text-red-600">Access denied.</div></Shell>} />

        {/* Participant */}
        <Route path="/participant/login" element={<Shell><ParticipantLogin /></Shell>} />
        <Route path="/participant" element={
          <Shell>
            <RequireRole allow={["participant","volunteer","admin"]}>
              <Participant />
            </RequireRole>
          </Shell>
        } />

        {/* Volunteer */}
        <Route path="/volunteer/login" element={<Shell><VolunteerLoginGoogle /></Shell>} />
        <Route path="/volunteer/checkin" element={
          <Shell>
            <RequireRole allow={["volunteer","admin"]}>
              <VolunteerCheckin />
            </RequireRole>
          </Shell>
        } />
        <Route path="/volunteer/teams" element={
          <Shell>
            <RequireRole allow={["volunteer","admin"]}>
              <VolunteerTeams />
            </RequireRole>
          </Shell>
        } />

        {/* Admin */}
        <Route path="/admin/login" element={<Shell><AdminLogin /></Shell>} />
        <Route path="/admin/slots" element={<Shell><RequireRole allow={["admin"]}><AdminSlots /></RequireRole></Shell>} />
        <Route path="/admin/rooms" element={<Shell><RequireRole allow={["admin"]}><AdminRooms /></RequireRole></Shell>} />
        <Route path="/admin/assign" element={<Shell><RequireRole allow={["admin"]}><AdminAssign /></RequireRole></Shell>} />
        <Route path="/admin/volunteers" element={<Shell><RequireRole allow={["admin"]}><AdminVolunteers /></RequireRole></Shell>} />
        <Route path="/admin/admins" element={<Shell><RequireRole allow={["admin"]}><AdminAdmins /></RequireRole></Shell>} />
        <Route path="/admin/analytics" element={<Shell><RequireRole allow={["admin"]}><AdminAnalytics /></RequireRole></Shell>} />
     <Route path="/admin/exceptions" element={<Shell><RequireRole allow={["admin"]}><AdminExceptions /></RequireRole></Shell>} />


<Route path="/participant/home" element={
  <Shell>
    <RequireRole allow={["participant"]}>
      <ParticipantHome />
    </RequireRole>
  </Shell>
} />

<Route path="/volunteer/home" element={
  <Shell>
    <RequireRole allow={["volunteer"]}>
      <VolunteerHome />
    </RequireRole>
  </Shell>
} />

<Route path="/admin/home" element={
  <Shell>
    <RequireRole allow={["admin"]}>
      <AdminHome />
    </RequireRole>
  </Shell>
} />

<Route
  path="/admin/teams"
  element={
    <Shell>
      <RequireRole allow={["admin"]}>
        <AdminTeams/>
      </RequireRole>
    </Shell>
  }
/>

      </Routes>
    </BrowserRouter>
  );
}
